<template>
  <v-container fluid class="employee-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/employee/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="employees-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="headers"
              :items="[
                ...employees.filter(employee=>employee.employeestatus=='New'),
                ...employees.filter(employee=>employee.employeestatus=='Active'),
                ...employees.filter(employee=>employee.employeestatus=='Contract'),
                ...employees.filter(employee=>employee.employeestatus=='Inactive'),
              ]"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Employee?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteemployee.employeename }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteemployee)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.employeeimage" size="35">
                  <img v-bind:src="item.employeeimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.employeename[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.employeename="{ item }">
                <p class="two-line">{{ item.employeename }}</p>
                <p class="two-line" v-if="item.userid!=null">{{ users.length>0 ? users.find(user=>user._id == item.userid)['userid'] : '' }}</p>
                <p class="two-line"><a class="primaryConst--text">{{ item.employeeemail }}</a></p>
              </template>
              <template v-slot:item.employeetype="{ item }">
                <p class="two-line">{{ item.employeetype }}</p>
                <p class="two-line">{{ item.employeetitle}}</p>
              </template>
              <template v-slot:item.employeeemail="{ item }">
                <a class="primaryConst--text">{{ item.employeeemail }}</a>
              </template>
              <template v-slot:item.employeestatus="{ item }">
                <p class="two-line">
                  <v-chip
                    :color="
                    item.employeestatus=='New' ? 'primaryConst white--text' : 
                    item.employeestatus=='Active' ? 'success white--text' : 
                    item.employeestatus=='Contract' ? 'orangeConst white--text' : 
                    item.employeestatus=='Inactive' ? 'greyTint white--text' : 
                    'secondaryConst white--text'" small>
                    {{ item.employeestatus }}
                  </v-chip>
                </p>
                <p style="margin-top: 5px; margin-bottom: 0px; margin-left: 5px;">
                  <v-img v-if="item.health.vaccinationstatus=='Full Vaccination' || item.health.vaccinationstatus.includes('Booster')" src="@/assets/vaccination_badge_30.png" contain max-width="22" min-width="22"></v-img>
                </p>
              </template>
              <template v-slot:item.employeestartdate="{ item }">
                {{ new Date(item.employeestartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.employeeenddate="{ item }">
                {{ item.employeeenddate!=null ? new Date(item.employeeenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printCardItem(item)">
                  <v-icon>mdi-credit-card-chip-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'EmployeeList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteemployee: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false, width: "8%" },
        { text: 'Name', value: 'employeename' },
        { text: 'Type & Title', value: 'employeetype', width: "20%" },
        { text: 'Status', value: 'employeestatus', width: "10%" },
        { text: 'Start', value: 'employeestartdate', width: "10%" },
        { text: 'End', value: 'employeeenddate', width: "10%" },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      switch1: true,
      employeeid: ['admin', 'employee'],
      editedIndex: -1,
      editedItem: {
        employeename: '',
        image: '',
        employeeid: '',
        company: '',
        employeetype: '',
        employeestatus: '',
        create: '',
      },
      defaultItem: {
        employeename: '',
        image: '',
        employeeid: '',
        company: '',
        employeetype: '',
        employeestatus: '',
        create: '',
      },
    }
  },

  computed: {
    ...mapState('Employee', ['employees', 'isReceiving', 'isDeleting', 'idToDelete', 'employeesMessage', 'isUpdating']),
    ...mapState('User', ['users']),
  },

  created () {
    this.getEmployeesRequest();
    if(this.users.length==0) this.getUsersRequest();
  },

  methods: {
    ...mapActions('Employee', ["getEmployeesRequest","deleteEmployeeRequest","updateEmployeeRequest","createEmployeeRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    editItem(item) {
      this.$router.push({ name: 'EmployeeEdit', params: item })
    },
    printCardItem(item) {
      this.$router.push({ name: 'EmployeeCard', params: item })
    },
    viewItem(item) {
      this.$router.push({ name: 'EmployeeView', params: item })
    },
    deleteItem(item) {
      console.log(item);
      //const pos = this.employees.map(function(employee) { return employee._id; }).indexOf(item._id);
      //this.employees.splice(pos, 1);
      this.deleteEmployeeRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteemployee = {
        _id: item._id,
        employeename: item.employeename,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
